import Header from '../../Plantilla/Header'; // Importa el componente Header
import Footer from '../../Plantilla/Footer'; // Importa el componente Footer
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../configuracion/config';
import { InsertarSede } from '../modales/modalInsertarSedes';
import ActualizarSede from '../modales/modalActualizarSedes';
import ResponsivePagination from './ResponsivePagination';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import { estiloAlertify } from '../Funciones';
import { authStorage } from '../../utils/storage';
import {
  faPlus,
  faFilter,
  faBroom,
  faMagnifyingGlass,
  faXmark,
  faFilePen,
  faTrash,
  faFaceFrown,
} from '@fortawesome/free-solid-svg-icons';
import './Sedes.css';

function TablaSedes() {
  const [sedes, setSedes] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('todos');
  const [mostrarModalInsertar, setMostrarModalInsertar] = useState(false);
  const [mostrarModalActualizar, setMostrarModal] = useState(false);
  const [drwSede, setDrwSede] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [isMobileView, setIsMobileView] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 576 : false
  );
  const userTipo = authStorage.getUserType();

  const load = async () => {
    try {
      const response = await api.post('/Sedes');

      if (response.status === 200) {
        setSedes(response.data);
      }
    } catch (error) {
      console.error('Error al obtener las Sedes:', error);
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(max-width: 575.98px)');
    const handleChange = (event) => {
      setIsMobileView(event.matches);
    };

    setIsMobileView(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const handlePageClick = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setPageNumber(0);
  };

  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
    setPageNumber(0);
  };

  const limpiarFiltros = () => {
    setSearchInput('');
    setEstadoFiltro('todos');
    setPageNumber(0);
  };

  const funcionMostrarModalInsertar = () => {
    setMostrarModalInsertar(true);
  };

  const funcionCerrarModalInsertar = () => {
    setMostrarModalInsertar(false);
  };

  const funcionGuardarSede = async (formulario) => {
    const { strSede, strDescripcion, bolEstado } = formulario;
    const dttSede = {
      strSede,
      strDescripcion,
      bolEstado
    };

    try {
      const buscarSede = await api.post(`/Sedes`);
      const sedeExistente = buscarSede.data.find(
        (sede) => sede.strSede.toLowerCase() === strSede.toLowerCase()
      );

      if (sedeExistente) {
        alertify.error(
          `Ya existe la Sede  ${sedeExistente.strSede} `
        );
        estiloAlertify(0);
        return;
      } 
      else 
      {  
          
          const response = await api.post('/InsertarSede', dttSede);
          if (response.status === 200) {
            load();
            alertify.success('Guardado');
            console.log(response);
            estiloAlertify(1);
            funcionCerrarModalInsertar();
          }
          //console.log(dttSede);
        
      }
    } catch (error) {
      console.error('Error al insertar la Sede:', error);
    }
  };

  const funcionEliminarSede = async (intIdSede) => {
    alertify
      .confirm('¿Está seguro que desea eliminar ésta Sede?', async (e) => {
        if (e) {
          try {
            // Realiza la llamada a la API para eliminar la sede
            const response = await api.delete(`/EliminarSede/${intIdSede}`);
  
            // Verifica si la respuesta del servidor fue exitosa
            if (response.status === 200) {             
              // Si la sede fue eliminada correctamente
              if (response.data === 'Eliminado') {
                setSedes(sedes.filter((item) => item.intIdSede !== intIdSede));
                load();
                alertify.success('Sede eliminada correctamente.');
                estiloAlertify(1);
              } 
              // Si la sede está asociada a anotaciones
              else if (response.data === 'Asociada') {
                alertify.warning('La sede ya se encuentra Asociada');
                estiloAlertify(3);
              }
            }
          } catch (error) {
            // Manejo de errores de la API
            if (error.response) {
                alertify.warning(error.response.data);
                estiloAlertify(3);
            } else if (error.request) {
              alertify.error('No se recibió respuesta del servidor.');
              estiloAlertify(0);
            } else {
              alertify.error(`Error al eliminar la sede: ${error.message}`);
              estiloAlertify(0);
            }
            
          }
        }
      })
      .set({
        labels: {
          ok: 'SI', // Etiqueta del botón OK
          cancel: 'NO', // Etiqueta del botón Cancelar
        },
        title: 'AVISO', // Título personalizado
      });
  };
  
  
 
  

  const funcionMostrarModalActualizar = (sede) => {
    setDrwSede({
      ...sede,
    });
    setMostrarModal(true);
  };

  const funcionCerrarModalActualizar = () => {
    setMostrarModal(false);
  };

  const funcionActualizarSede = async (sedeActualizar) => {
    if (sedeActualizar.intIdSede) {
      try {

          const response = await api.put(`/ActualizarSede/${sedeActualizar.intIdSede}`,sedeActualizar);
          if (response.status === 200) {
            load();
            alertify.success('Guardado.');
            estiloAlertify(1);
            funcionCerrarModalActualizar();
          }
        
      } catch (error) {
        console.error('Error al actualizar la anotación:', error);
      }
    }
  };

  // Lógica para aplicar el filtro
  const filteredData = sedes.filter((drw) => {
    const formattedSearchInput = searchInput.toLowerCase();
    const usuarioMatch = drw.strSede
      .toLowerCase()
      .includes(formattedSearchInput);
    const nomnreMatch = drw.strDescripcion
      .toLowerCase()
      .includes(formattedSearchInput);
    const filtroTexto = usuarioMatch || nomnreMatch;
    const filtroEstado =
      estadoFiltro === 'todos' ||
      (estadoFiltro === 'activo' ? drw.bolEstado : !drw.bolEstado);
    return filtroTexto && filtroEstado;
  });

  // Lógica para la paginación
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const currentPage =
    pageCount > 0 ? Math.min(pageNumber, pageCount - 1) : 0;
  const offset = currentPage * itemsPerPage;
  const paginatedData = filteredData.slice(offset, offset + itemsPerPage);
  const hayFiltrosActivos = searchInput !== '' || estadoFiltro !== 'todos';
  const goToFirstPage = () => setPageNumber(0);
  const goToLastPage = () => setPageNumber(Math.max(pageCount - 1, 0));
  const mostrarSedesComoCards =
    isMobileView && (itemsPerPage === 10 || itemsPerPage === 50);
  const mostrarSedesDosPorFila = isMobileView && itemsPerPage === 50;
  return (
    <div className="sedes-page">
      <header>
        <Header />
      </header>
      {userTipo === 'admin' ? (
        <main className="container-fluid mt-2" style={{ flex: '1', minHeight: 'calc(100vh - 20px)' }} >
          <div className="row g-3">
            <div className="col-xl-3 col-lg-4">
              <div className="card border-0 shadow-sm p-3 sedes-filter-card">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6 className="m-0 text-secondary">
                    <FontAwesomeIcon icon={faFilter} className="me-2" />
                    Filtros
                  </h6>
                  {hayFiltrosActivos && (
                    <span className="badge rounded-pill text-bg-light border">
                      Activos
                    </span>
                  )}
                </div>

                <div className="form-group small">
                  <label htmlFor="filtroSede">Sede / descripción</label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text">
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </span>
                    <input
                      id="filtroSede"
                      type="text"
                      className="form-control"
                      placeholder="Ej. Norte o Bodega"
                      value={searchInput}
                      onChange={handleInputChange}
                    />
                    {searchInput && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setSearchInput('')}
                        title="Limpiar texto"
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    )}
                  </div>
                </div>

                <div className="form-group small mt-2">
                  <label htmlFor="estadoFiltroSede">Estado</label>
                  <select
                    id="estadoFiltroSede"
                    className="form-control form-control-sm"
                    value={estadoFiltro}
                    onChange={(e) => {
                      setEstadoFiltro(e.target.value);
                      setPageNumber(0);
                    }}
                  >
                    <option value="todos">Todos</option>
                    <option value="activo">Activos</option>
                    <option value="inactivo">Inactivos</option>
                  </select>
                </div>

                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm mt-3"
                  onClick={limpiarFiltros}
                >
                  <FontAwesomeIcon icon={faBroom} className="me-2" />
                  Limpiar filtros
                </button>
              </div>
            </div>

            <div className="col-xl-9 col-lg-8">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white">
                  <div className="row g-2 align-items-center">
                    <div className="col-md-8 ">
                      <h5 className="card-title text-secondary mb-0">Sedes</h5>
                      <small className="text-muted">
                        {filteredData.length} resultado{filteredData.length === 1 ? '' : 's'}
                      </small>
                    </div>
                    <div className="col-md-4 text-md-end">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={funcionMostrarModalInsertar}
                      >
                        <FontAwesomeIcon icon={faPlus} className="me-1" /> Nueva
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-end align-items-center gap-2 small mb-3">
                    <label htmlFor="itemsPerPageSedes" className="text-secondary mb-0">
                      Mostrar
                    </label>
                    <select
                      id="itemsPerPageSedes"
                      className="form-select form-select-sm w-auto"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                    >
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <span className="text-secondary">registros</span>
                  </div>
                  {mostrarSedesComoCards ? (
                    <div
                      className={`sedes-mobile-list ${
                        mostrarSedesDosPorFila ? 'sedes-mobile-list--two-columns' : ''
                      }`}
                    >
                      {paginatedData.length === 0 ? (
                        <div className="card sedes-mobile-card">
                          <div className="card-body text-center text-muted py-4">
                            No hay sedes para los filtros seleccionados.
                          </div>
                        </div>
                      ) : (
                        paginatedData.map((drw) => (
                          <div
                            key={drw.intIdSede}
                            className={`card sedes-mobile-card ${
                              drw.bolEstado
                                ? 'sedes-mobile-card--activo'
                                : 'sedes-mobile-card--inactivo'
                            }`}
                          >
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-start gap-2 mb-3 sedes-mobile-header">
                                <div className="sedes-mobile-identity">
                                  <span className="sedes-mobile-overline">Sede</span>
                                  <h6 className="mb-1 sedes-mobile-title">{drw.strSede}</h6>
                                  <p className="mb-0 small sedes-mobile-subtitle">
                                    {drw.strDescripcion}
                                  </p>
                                </div>
                                <span
                                  className={`badge rounded-pill sedes-mobile-status ${
                                    drw.bolEstado
                                      ? 'sedes-mobile-status--activo'
                                      : 'sedes-mobile-status--inactivo'
                                  }`}
                                >
                                  {drw.bolEstado ? 'Activo' : 'Inactivo'}
                                </span>
                              </div>

                              <div className="sedes-mobile-fields small">
                                <div className="sedes-mobile-field">
                                  <span className="sedes-mobile-label">ID</span>
                                  <span className="sedes-mobile-value">{drw.intIdSede}</span>
                                </div>
                                <div className="sedes-mobile-field">
                                  <span className="sedes-mobile-label">Sede</span>
                                  <span className="sedes-mobile-value">{drw.strSede}</span>
                                </div>
                                <div className="sedes-mobile-field">
                                  <span className="sedes-mobile-label">Descripcion</span>
                                  <span className="sedes-mobile-value">{drw.strDescripcion}</span>
                                </div>
                              </div>

                              <div className="d-flex justify-content-end gap-2 mt-3 sedes-mobile-actions">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm sedes-mobile-action-btn"
                                  onClick={() => funcionMostrarModalActualizar(drw)}
                                  title="Editar sede"
                                >
                                  <FontAwesomeIcon icon={faFilePen} className="me-1" />
                                  Editar
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm sedes-mobile-action-btn"
                                  onClick={() => funcionEliminarSede(drw.intIdSede)}
                                  title="Eliminar sede"
                                >
                                  <FontAwesomeIcon icon={faTrash} className="me-1" />
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  ) : (
                    <div className="table-responsive tablescroll sedes-table-wrapper">
                      <table className="table  table-hover table-sm table-bordered">
                        <thead className="table table-light">
                          <tr>
                            <th className="text-secondary small col-1">ID</th>
                            <th className="text-secondary small ">Sede</th>
                            <th className="text-secondary small ">Descripcion</th>
                            <th className="text-secondary small text-center ">Estado</th>
                            <th className="small col-1  text-center text-white bg-success ">
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody className="small align-middle">
                          {paginatedData.length === 0 ? (
                            <tr>
                              <td colSpan="5" className="text-center text-muted py-4">
                                No hay sedes para los filtros seleccionados.
                              </td>
                            </tr>
                          ) : (
                            paginatedData.map((drw) => (
                              <tr key={drw.intIdSede}>
                                <td className="small">{drw.intIdSede}</td>
                                <td className="small">{drw.strSede}</td>
                                <td className="small">{drw.strDescripcion}</td>
                                <td className= {`small text-center ${drw.bolEstado === false ? 'text-danger' : '' }`} >{drw.bolEstado ? 'Activo' : 'Inactivo'}</td>
                                <td className=" text-center ">
                                  <div
                                    className="btn-group "
                                    role="group"
                                    aria-label=""
                                  >
                                    <button
                                      className="btn btn-sm "
                                      onClick={() =>
                                        funcionMostrarModalActualizar(drw)
                                      }
                                      title="Editar sede"
                                    >
                                      <FontAwesomeIcon
                                        icon={faFilePen}
                                        className="text-secondary"
                                      />
                                    </button>
                                    <button
                                      className="btn  btn-sm"
                                      onClick={() =>
                                        funcionEliminarSede(drw.intIdSede)
                                      }
                                      title="Eliminar sede"
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrash}
                                        className="text-danger"
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div className="card-footer bg-white">
                  <ResponsivePagination
                    pageCount={pageCount}
                    currentPage={currentPage}
                    onPageChange={handlePageClick}
                    onFirstPage={goToFirstPage}
                    onLastPage={goToLastPage}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <InsertarSede
              mostrarModalInsertar={mostrarModalInsertar}
              cerrarModalInsertar={funcionCerrarModalInsertar}
              guardarModalInsertar={funcionGuardarSede}
            />
            {drwSede && (
              <ActualizarSede
                mostrarModalActualizar={mostrarModalActualizar}
                cerrarModalActualizar={funcionCerrarModalActualizar}
                actualizarModal={funcionActualizarSede}
                drwSede={drwSede}
              />
            )}
          </div>
        </main>
      ) : (
        <div className="container ">
          <div className="row mt-5">
            <FontAwesomeIcon
              icon={faFaceFrown}
              beat
              size="4x"
              style={{ color: '#9aaf98' }}
            />
          </div>
          <div className="row mt-3 text-center">
            <p className="text-secondary">Página no encontrada ...</p>
          </div>
        </div>
      )}

      <footer>
         <Footer />
      </footer>
    </div>
  );
}

export default TablaSedes;
